import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });

export const getToken = () => localStorage.getItem("cd_token");
export const setToken = (t) => (t ? localStorage.setItem("cd_token", t) : localStorage.removeItem("cd_token"));

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config.url.includes("/auth/")) {
      setToken(null);
      window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!e?.response) return "Network error — check your connection.";
  if (d == null) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d.blockers) return `${d.message}: ${d.blockers.join("; ")}`;
  if (d.message) return d.message + (d.fields ? `: ${d.fields.join(", ")}` : "");
  return String(d);
}

export const fileUrl = (id, download = false) => `${BACKEND}/api/files/${id}?auth=${getToken()}${download ? "&download=true" : ""}`;

export const uid = () => (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
